import { render, staticRenderFns } from "./EntityDetails.vue?vue&type=template&id=79d3edba"
import script from "./EntityDetails.vue?vue&type=script&lang=js"
export * from "./EntityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports